exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Checkbox-module__checkbox-background___4S5u5{font-size:20px;color:#242c40;display:flex;justify-content:center;align-items:center}.Checkbox-module__checkbox-background___4S5u5.Checkbox-module__dark___326fp,.Checkbox-module__checkbox-background___4S5u5.Checkbox-module__dark___326fp p{color:#fff}.Checkbox-module__checkbox-background___4S5u5.Checkbox-module__hoverCheck___1W7rH:hover{background:#8fc2ef;cursor:pointer}.Checkbox-module__checkbox-background___4S5u5 .Checkbox-module__icon___1rSJf{width:12px;height:auto}.Checkbox-module__checkbox-background___4S5u5 p{margin-left:5px;cursor:pointer}.Checkbox-module__checkbox-background___4S5u5 svg{cursor:pointer}", ""]);

// exports
exports.locals = {
	"checkbox-background": "Checkbox-module__checkbox-background___4S5u5",
	"dark": "Checkbox-module__dark___326fp",
	"hoverCheck": "Checkbox-module__hoverCheck___1W7rH",
	"icon": "Checkbox-module__icon___1rSJf"
};